export default __webpack_public_path__ + "assets/audios/f14e6aed0201a72f84e3861e852b5efe.mp3";